import { VersionModel } from "../../../../helper/version/Version.model";
import { SET_VERSION } from "./action";

let defaultState = new VersionModel();

export default function versionReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_VERSION:
            return action.versionModel;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/services/store/reducers/version/index.js